import App from "./Wisch/App.svelte";
import { nanoid } from "nanoid";

setTimeout(() => {
    const location = window.location;
    if (location.hash) {
        history.replaceState("", document.title, location.pathname + location.search);
    }

    [...document.querySelectorAll("[data-wisch]")].forEach((target) => {
        const data = target.dataset;
        const id = `i` + nanoid();
        target.id = id;
        new App({
            target,
            props: {
                id,
                type: data.wisch,
                itemId: data.itemId,
                adSpread: parseInt(data.adSpread),
                adTimeout: parseInt(data.adTimeout),
            },
        });
    });
}, 500);
